import { useState } from 'react';
import { Link } from 'react-router-dom';

const allPhotos = [
  {
    url: 'https://www.dropbox.com/scl/fi/6ijtjweav8jo2ts4i72f4/Photo-25-02-2026-19-32-00.jpg?rlkey=za23t0apnz8mql0er26rk309f&st=hw76butd&raw=1',
    alt: 'Chalet Lac de Vonnes interior',
  },
  {
    url: 'https://www.dropbox.com/scl/fi/1vn6vi4m5mag1tfrnou8p/Photo-29-01-2026-07-33-04.jpg?rlkey=jct21h1qni31ve6uphc4fahoj&st=r4ip3x5h&raw=1',
    alt: 'Chalet Lac de Vonnes',
  },
  {
    url: 'https://www.dropbox.com/scl/fi/lda42d7jxxgdt365gxcnt/Photo-03-02-2026-14-04-38.jpg?rlkey=yg58hmzdakd2tbdeo1tjz6hjx&st=zr9necn0&raw=1',
    alt: 'Chalet Lac de Vonnes',
  },
  {
    url: 'https://www.dropbox.com/scl/fi/ifwblpnt2z3q9hr2er4b7/Photo-02-02-2026-18-37-29.jpg?rlkey=lksrvzv535ym9soc71x1435gy&st=oydz80uh&raw=1',
    alt: 'Chalet Lac de Vonnes',
  },
  {
    url: 'https://www.dropbox.com/scl/fi/4kov3et59mhqdcpiegben/Photo-11-01-2025-17-34-52.jpg?rlkey=5lpvi0eiznzgdumaigliyuf1i&st=qld41dis&raw=1',
    alt: 'Chalet Lac de Vonnes',
  },
  {
    url: 'https://www.dropbox.com/scl/fi/rzbp4i3tlik1329aakqx6/Photo-17-01-2025-15-30-26.jpg?rlkey=q8wan14owwo0bg99fuzqxzhrx&st=q98tofpv&raw=1',
    alt: 'Chalet Lac de Vonnes',
  },
  {
    url: 'https://www.dropbox.com/scl/fi/ulr66u8r1hh5qg60ldrbd/Photo-12-01-2026-17-19-37.jpg?rlkey=geurzyo8sf1gi19nq2kq64oxg&st=qxssnaal&raw=1',
    alt: 'Chalet Lac de Vonnes',
  },
  {
    url: 'https://www.dropbox.com/scl/fi/lzq2j5tmc1ep8poocxpn3/Photo-12-01-2025-11-13-08.jpg?rlkey=i3ii0zeko7bdsr2180zzkuy60&st=7se9jo75&raw=1',
    alt: 'Chalet Lac de Vonnes',
  },
  {
    url: 'https://www.dropbox.com/scl/fi/5kbgrll3kw2znn70kaxih/Photo-04-03-2026-15-02-56.jpg?rlkey=u6wijv4dflmkq45af58ugdf7w&st=ulecrxgq&raw=1',
    alt: 'Chalet Lac de Vonnes',
  },
  {
    url: 'https://www.dropbox.com/scl/fi/bm8cxv69mt6s7bjhlk061/Photo-04-03-2026-15-03-19.jpg?rlkey=vulcdcs1lbcziev5or2l9z0hi&st=36aaarjy&raw=1',
    alt: 'Chalet Lac de Vonnes',
  },
  {
    url: 'https://dynamic-media-cdn.tripadvisor.com/media/photo-o/13/93/c3/54/new-hot-tub-overlooking.jpg?w=1400&h=-1&s=1',
    alt: 'Chalet Lac de Vonnes hot tub overlooking the Alps',
  },
];

export default function GalleryPage() {
  const [lightbox, setLightbox] = useState<number | null>(null);

  const openLightbox = (index: number) => setLightbox(index);
  const closeLightbox = () => setLightbox(null);
  const prevPhoto = () => setLightbox((prev) => (prev !== null ? (prev - 1 + allPhotos.length) % allPhotos.length : null));
  const nextPhoto = () => setLightbox((prev) => (prev !== null ? (prev + 1) % allPhotos.length : null));

  return (
    <div className="min-h-screen bg-white pb-28">
      {/* Top Nav */}
      <nav className="w-full px-12 py-6 flex items-center justify-between border-b border-gray-100">
        <Link to="/" className="flex items-center gap-2 text-gray-500 hover:text-gray-900 transition-colors cursor-pointer whitespace-nowrap">
          <i className="ri-arrow-left-line text-lg"></i>
          <span className="text-sm font-light tracking-widest uppercase">Back to Home</span>
        </Link>
        <div className="text-center">
          <p className="text-xs font-semibold tracking-widest uppercase" style={{ color: '#D4AF37' }}>
            Chalet Lac de Vonnes
          </p>
          <h1 className="text-2xl font-thin tracking-widest text-gray-900 uppercase" style={{ letterSpacing: '3px' }}>
            Full Gallery
          </h1>
        </div>
        <div className="w-40" />
      </nav>

      {/* Gallery Grid */}
      <main className="px-12 py-16 max-w-7xl mx-auto">
        <p className="text-center text-sm font-light text-gray-400 tracking-widest uppercase mb-12">
          {allPhotos.length} Photos
        </p>
        <div className="columns-3 gap-4 space-y-4">
          {allPhotos.map((photo, index) => (
            <div
              key={index}
              className="break-inside-avoid rounded-xl overflow-hidden cursor-pointer group relative"
              onClick={() => openLightbox(index)}
            >
              <img
                src={photo.url}
                alt={photo.alt}
                className="w-full h-auto object-cover object-center transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300 flex items-center justify-center">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/80 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <i className="ri-zoom-in-line text-gray-800 text-lg"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </main>

      {/* Enquiry CTA Section */}
      <section className="w-full px-12 py-20 border-t border-gray-100" style={{ backgroundColor: '#F8F6F2' }}>
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-xs font-semibold tracking-widest uppercase mb-4" style={{ color: '#D4AF37' }}>
            Ready to Experience It?
          </p>
          <h2 className="text-4xl md:text-5xl font-thin tracking-wider text-gray-900 mb-6" style={{ letterSpacing: '2px' }}>
            MAKE AN ENQUIRY
          </h2>
          <p className="text-lg font-light text-gray-500 leading-relaxed mb-10">
            Inspired by what you see? Get in touch with our team to check availability, ask questions, or reserve your alpine escape.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/#contact"
              className="group flex items-center gap-3 px-10 py-5 rounded-full text-white text-base font-light tracking-wide transition-all duration-300 hover:opacity-90 hover:scale-105 cursor-pointer whitespace-nowrap shadow-lg"
              style={{ backgroundColor: '#2B2B2B' }}
            >
              <i className="ri-mail-send-line text-lg"></i>
              <span>Send an Enquiry</span>
            </Link>
            <a
              href="mailto:info@vonnesalpinelife.eu"
              className="group flex items-center gap-3 px-10 py-5 rounded-full text-gray-800 text-base font-light tracking-wide border border-gray-300 hover:border-gray-800 transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-mail-line text-lg"></i>
              <span>info@vonnesalpinelife.eu</span>
            </a>
          </div>
        </div>
      </section>

      {/* Sticky Bottom CTA Bar */}
      <div className="fixed bottom-0 left-0 right-0 z-40 flex items-center justify-between px-12 py-4 shadow-2xl" style={{ backgroundColor: '#2B2B2B' }}>
        <div className="flex items-center gap-4">
          <div className="w-8 h-8 flex items-center justify-center rounded-full" style={{ backgroundColor: '#D4AF37' }}>
            <i className="ri-home-4-line text-sm text-white"></i>
          </div>
          <div>
            <p className="text-white text-sm font-light tracking-wide">Chalet Lac de Vonnes</p>
            <p className="text-gray-400 text-xs font-light tracking-widest uppercase">Châtel, French Alps</p>
          </div>
        </div>
        <p className="text-gray-400 text-sm font-light hidden md:block">
          Loved what you saw? Reserve your stay today.
        </p>
        <Link
          to="/#contact"
          className="flex items-center gap-3 px-8 py-3 rounded-full text-gray-900 text-sm font-medium tracking-wide transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap"
          style={{ backgroundColor: '#D4AF37' }}
        >
          <i className="ri-calendar-check-line text-base"></i>
          <span>Book Now</span>
        </Link>
      </div>

      {/* Lightbox */}
      {lightbox !== null && (
        <div
          className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center"
          onClick={closeLightbox}
        >
          <button
            className="absolute top-6 right-8 w-10 h-10 flex items-center justify-center text-white/70 hover:text-white transition-colors cursor-pointer z-10"
            onClick={closeLightbox}
          >
            <i className="ri-close-line text-2xl"></i>
          </button>
          <button
            className="absolute left-6 w-12 h-12 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 text-white transition-all cursor-pointer z-10"
            onClick={(e) => { e.stopPropagation(); prevPhoto(); }}
          >
            <i className="ri-arrow-left-s-line text-2xl"></i>
          </button>
          <div
            className="max-w-5xl max-h-screen px-20 py-12"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={allPhotos[lightbox].url}
              alt={allPhotos[lightbox].alt}
              className="max-w-full max-h-[80vh] object-contain rounded-lg shadow-2xl mx-auto block"
            />
            <p className="text-center text-white/40 text-sm mt-4 tracking-widest">
              {lightbox + 1} / {allPhotos.length}
            </p>
          </div>
          <button
            className="absolute right-6 w-12 h-12 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 text-white transition-all cursor-pointer z-10"
            onClick={(e) => { e.stopPropagation(); nextPhoto(); }}
          >
            <i className="ri-arrow-right-s-line text-2xl"></i>
          </button>
        </div>
      )}
    </div>
  );
}
